import { FC, useCallback, useMemo } from 'react';

import { Link } from 'react-router-dom';
import cn from 'classnames';
import { useAppWrapperContext } from 'ui/layouts/AppWrapper';
import { useAdminParams } from 'utils/helpers';
import { Lead } from 'utils/types';

import { useGetCompanyContactDetails } from '../hooks';

interface PROPS {
  id: string;
}

const ContactContacts: FC<PROPS> = ({ id }) => {
  const { data: contacts } = useGetCompanyContactDetails(id as string, {
    include: ['leads', 'tag'],
  });

  const {
    state: { isPreview },
  } = useAppWrapperContext();
  const { accountId, accountUserId } = useAdminParams();

  const link = useCallback(
    (contact: Lead) => {
      if (!isPreview) return `/contact/leads/${contact._id}`;

      return `/preview/accounts/${accountId}/users/${accountUserId}/contact/leads/${contact._id}`;
    },
    [isPreview, accountId, accountUserId],
  );

  const viewAllLink = useMemo(() => {
    if (!isPreview) return `/contact/leads`;

    return `/preview/accounts/${accountId}/users/${accountUserId}/contact/leads`;
  }, [isPreview, accountId, accountUserId]);

  return (
    <div>
      <div
        className={cn(
          'text-xs pt-5 mt-[18px]',
          'border-t-[0.5px] border-separator-primary',
          'flex flex-col space-y-3',
        )}
      >
        {!contacts?.leads?.length ? (
          <p className="text-xs">See the Contacts attached to this record</p>
        ) : (
          contacts?.leads?.map((contact: any) => (
            <div
              key={contact._id}
              className={cn(
                'bg-[#F7FAFF]',
                'border',
                'text-xs',
                'border-[#E6F0FF]',
                'rounded-[6px]',
                'pt-[22px]',
                'pb-[18px]',
                'px-[22px]',
                'space-y-2',
              )}
            >
              <div>
                <Link
                  className={cn(
                    'leading-[22px] text-sm font-semibold text-[#1973E8] tracking-[0.04em]',
                  )}
                  to={link(contact)}
                >
                  {contact.fullName}
                </Link>
              </div>
              <div className="leading-5 text-secondary">
                <div>{contact.emailAddress}</div>
                <div>{contact.businessNumber || contact.mobileNumber}</div>
              </div>
            </div>
          ))
        )}
      </div>
      {!contacts?.leads?.length ? null : (
        <div className="text-center mt-2">
          <Link
            className="leading-[22px] text-sm font-semibold tracking-[0.04em]"
            to={viewAllLink}
          >
            View all contacts
          </Link>
        </div>
      )}
    </div>
  );
};

export default ContactContacts;
